import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { DEFAULT_LEARNING_LANGUAGE_CODE, normalizeLearningLanguageCode } from '../constants/learningLanguages';
import { clearPendingAuthJourney, getPendingAuthJourney } from './authJourney';
import {
  DEFAULT_ONBOARDING_STATE,
  mergeOnboardingStateWithJourney,
  resolveOnboardingResumePath,
} from '../contexts/onboardingHelpers';

const ONBOARDING_STORAGE_KEY = 'aprendos_onboarding_state';

function resolveUserLearningLanguage(userData = {}) {
  const activeLanguages = Array.isArray(userData.activeLearningLanguages)
    ? userData.activeLearningLanguages
    : [];

  return normalizeLearningLanguageCode(
    userData.preferredLearningLanguage
      || userData.learningLanguage
      || activeLanguages[0],
    DEFAULT_LEARNING_LANGUAGE_CODE
  );
}

function resolveSavedOnboardingPath() {
  if (typeof window === 'undefined') return '/onboarding';

  let savedState = DEFAULT_ONBOARDING_STATE;
  try {
    const serializedState = window.localStorage.getItem(ONBOARDING_STORAGE_KEY);
    if (serializedState) {
      savedState = { ...DEFAULT_ONBOARDING_STATE, ...JSON.parse(serializedState) };
    }
  } catch {
    // A malformed local state should fall back to the beginning of onboarding.
  }

  const pendingJourney = getPendingAuthJourney(window.sessionStorage);
  return resolveOnboardingResumePath(
    mergeOnboardingStateWithJourney(savedState, pendingJourney)
  );
}

export async function resolvePostAuthPath(user) {
  if (!user?.uid) {
    return '/onboarding';
  }

  const savedOnboardingPath = resolveSavedOnboardingPath();

  try {
    const userDoc = await getDoc(doc(db, 'users', user.uid));

    if (!userDoc.exists()) {
      return savedOnboardingPath;
    }

    const userData = userDoc.data() || {};
    const lang = resolveUserLearningLanguage(userData);
    if (userData.onboardingCompleted) {
      if (typeof window !== 'undefined') {
        clearPendingAuthJourney(window.sessionStorage);
      }
      return `/${lang}/dashboard`;
    }

    if (savedOnboardingPath !== '/onboarding') {
      return savedOnboardingPath;
    }

    if (userData.learningLanguage || userData.preferredLearningLanguage) {
      return `/${lang}/onboarding/welcome`;
    }
  } catch (error) {
    console.error('Error resolving post-auth path:', error);
  }

  return savedOnboardingPath;
}
